import { Application } from '../../helpers/app'
// import 'regenerator-runtime/runtime'
// import './moving-page.pug'
import './moving-page.scss'
import '../../components/hero/hero.component'
import '../../components/moving-process/moving-process.component'
import * as movingSelectComponent from '../../components/moving-select/moving-select.component'
import '../../components/moving-features/moving-features.component'
import '../../components/useful/useful.component'
import '../../components/partners/partners.component'
import '../../components/reviews/reviews.component'
import '../../components/subscribe/subscribe.component'

movingSelectComponent.activate();

Application.run()
